import React from 'react';
import PropTypes from 'prop-types';

import Box from '@quintoandar/cozy-core/Box';
import FeedbackBlock from '@quintoandar/cozy-core/FeedbackBlock';
import Close from '@quintoandar/cozy-icons/Close';

import globalMessages from 'messages/globalMessages';

export const RetryFeedback = ({ title, subtitle, onRetry }) => (
  <Box mt={4}>
    <FeedbackBlock
      kind="critical"
      icon={Close}
      title={title}
      subtitle={subtitle}
      buttonLabel={globalMessages.tryAgain}
      buttonClick={onRetry}
    />
  </Box>
);

RetryFeedback.propTypes = {
  title: PropTypes.object.isRequired,
  subtitle: PropTypes.object,
  onRetry: PropTypes.func.isRequired,
};

RetryFeedback.defaultProps = {
  subtitle: globalMessages.connectionErrorSubtitle,
};

export default RetryFeedback;
